import React from 'react';
import { ComplexSeparator } from '../Layout/complex-separator';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderSeparator = () => /*#__PURE__*/_jsx(ComplexSeparator, {
  styles: {
    root: {
      width: 1,
      height: '80%',
      selectors: {
        ':before': {
          height: '18px',
          top: 5,
          width: '100%'
        }
      },
      marginRight: 5,
      marginLeft: 5
    }
  }
});